import { Flex } from '@chakra-ui/react'

import { useUser } from '@/client/context/user'
import type { Query } from '@/client/query'

import getCurrentStreak from '@/components/Series/SeriesStreakBar/internal/getCurrentStreak'
import getLongestStreak from '@/components/Series/SeriesStreakBar/internal/getLongestStreak'
import getSeriesStreakItems from '@/components/Series/SeriesStreakBar/internal/getSeriesStreakItems'
import SeriesStreakItems from '@/components/Series/SeriesStreakBar/SeriesStreakItems'
import SeriesStreakStatus from '@/components/Series/SeriesStreakBar/SeriesStreakStatus'

export default function SeriesStreakBar({ series }: { series: Query }) {
  const user = useUser()

  const items = getSeriesStreakItems({ series, userId: user.id })

  if (items.length < 2) {
    return null
  }

  const longestStreak = getLongestStreak(items)
  const currentStreak = getCurrentStreak(items)

  const hasUpcomingSessions = items[items.length - 1].hasEnded === false

  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      alignItems="center"
      justifyContent={{ md: 'flex-start' }}
    >
      <SeriesStreakItems items={items} hasUpcomingSessions={hasUpcomingSessions} />
      <SeriesStreakStatus
        hasUpcomingSessions={hasUpcomingSessions}
        currentStreak={currentStreak}
        longestStreak={longestStreak}
      />
    </Flex>
  )
}
